import {ApiResponse} from '../models/ApiResponse';
import {EntityLikes} from '../models/Likes/LikeModel';
import {apiClient, withAuth} from './baseApiClient';

class LikesAPI {
  public async getEntityLikes(
    entityId: string,
  ): Promise<ApiResponse<EntityLikes>> {
    const headers = await withAuth({});
    return apiClient.get(`/Like/entity/${entityId}`, {headers});
  }
}

export default LikesAPI;
